// extracted by mini-css-extract-plugin
export default {"root":"BaseButton_root__r-uXF"};